/**
 * Vinci Region Pricing – v3
 *
 * Dois modos:
 * 1) [data-vr-price]   → troca simples de texto (preço da loja selecionada)
 * 2) [data-vr-pricing]  → container rico com JSON pré-computado
 *    Atualiza: selling, compare (de/por), PIX e parcelas
 */
(() => {
  const STORAGE_KEY = "vinci_region";

  function getCookieRaw(n) {
    const m = document.cookie.match(new RegExp("(^| )" + n + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : null;
  }

  function safeParse(str) {
    try { return JSON.parse(str); } catch (e) { return null; }
  }

  function getSelectionCode() {
    const rawLS = window.localStorage?.getItem(STORAGE_KEY);
    const objLS = safeParse(rawLS);
    if (objLS?.code) return String(objLS.code).trim();

    const rawCK = getCookieRaw(STORAGE_KEY);
    const objCK = safeParse(rawCK);
    if (objCK?.code) return String(objCK.code).trim();

    return "";
  }

  /* ── Modo simples: [data-vr-price] ── */
  function applySimple(root) {
    const code = getSelectionCode();
    const nodes = root.querySelectorAll?.("[data-vr-price]") || [];

    nodes.forEach(el => {
      const def = (el.getAttribute("data-vr-default") || "").trim();
      if (!code) {
        if (def && el.textContent.trim() !== def) el.textContent = def;
        return;
      }
      const attr = "data-vr-" + code;
      const val = (el.getAttribute(attr) || "").trim();
      const next = val || def;
      if (next && el.textContent.trim() !== next) el.textContent = next;
    });
  }

  /* ── Verifica se preço é zero ── */
  function isZeroPrice(priceStr) {
    if (!priceStr) return true;
    const num = parseFloat(priceStr.replace(/[^\d,]/g, '').replace(',', '.'));
    return isNaN(num) || num <= 0;
  }

  /* ── Modo rico: [data-vr-pricing] ── */
  function applyRich(root) {
    const code = getSelectionCode();
    const containers = root.querySelectorAll?.("[data-vr-pricing]") || [];

    containers.forEach(ctn => {
      const dataEl = ctn.querySelector("script.vr-price-data");
      if (!dataEl) return;

      let allData;
      try { allData = JSON.parse(dataEl.textContent); } catch (e) { return; }

      const d = (code && allData[code]) || allData["default"];
      if (!d) return;

      // Verifica se o preço é zero OU se não tem estoque na região (produto indisponível)
      const priceIsZero = isZeroPrice(d.selling);
      const stockUnavailable = d.available === false;
      const unavailableEl = ctn.querySelector("[data-vr-unavailable]");
      const priceEls = ctn.querySelectorAll("[data-vr-price-row]");

      // O botão Comprar só deve ser tocado quando o ctn é o do produto principal (bgz-product__prices)
      // Cards de vitrine (bgz-card__prices) NÃO podem mexer no botão principal
      const isMainProduct = ctn.classList.contains('bgz-product__prices');
      const buyBtn = isMainProduct ? document.querySelector('.bgz-product__buy-btn') : null;

      if ((priceIsZero || stockUnavailable) && code) {
        // Esconde preços e mostra indisponível
        priceEls.forEach(el => { el.hidden = true; el.style.display = "none"; });
        if (unavailableEl) { unavailableEl.hidden = false; unavailableEl.style.display = ""; }
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Indisponível'; }
        // Marca o card como indisponível
        const card = ctn.closest('.bgz-card');
        if (card) card.setAttribute('data-vr-zero', 'true');
        // Anti-FOUC: marca como pronto pra exibir
        ctn.classList.add('vr-ready');
        if (buyBtn) buyBtn.classList.add('vr-ready');
        return;
      }

      // Preço disponível - mostra normalmente
      priceEls.forEach(el => { el.hidden = false; el.style.display = ""; });
      if (unavailableEl) { unavailableEl.hidden = true; unavailableEl.style.display = "none"; }
      if (buyBtn && (buyBtn.textContent === 'Indisponível' || buyBtn.textContent === 'Indisponivel')) {
        buyBtn.disabled = false;
        buyBtn.textContent = 'Comprar';
      }
      const card = ctn.closest('.bgz-card');
      if (card) card.removeAttribute('data-vr-zero');

      // Selling price (preço principal)
      const selEl = ctn.querySelector('[data-vr-el="selling"]');
      if (selEl && d.selling) selEl.textContent = d.selling;

      // Compare / De: (preço riscado)
      const cmpRow = ctn.querySelector("[data-vr-compare-row]");
      const cmpEl = ctn.querySelector('[data-vr-el="compare"]');
      if (cmpRow) {
        if (d.compare) {
          if (cmpEl) cmpEl.textContent = d.compare;
          cmpRow.hidden = false;
          cmpRow.style.display = "";
        } else {
          cmpRow.hidden = true;
          cmpRow.style.display = "none";
        }
      }

      // PIX
      const pixEl = ctn.querySelector('[data-vr-el="pix"]');
      if (pixEl && d.pix) pixEl.textContent = d.pix;

      // Parcelas
      const instEl = ctn.querySelector('[data-vr-el="installment"]');
      if (instEl) {
        const instRow = instEl.closest('[data-vr-price-row]');
        if (d.installment) {
          instEl.textContent = d.installment;
          if (instRow) { instRow.hidden = false; instRow.style.display = ""; }
        } else {
          instEl.textContent = "";
          if (instRow) { instRow.hidden = true; instRow.style.display = "none"; }
        }
      }

      // Anti-FOUC: marca como pronto pra exibir
      ctn.classList.add('vr-ready');
      if (buyBtn) buyBtn.classList.add('vr-ready');
    });
  }

  /* ── Aplicar ambos os modos ── */
  let applying = false;
  let scheduled = false;

  function apply(root) {
    if (applying) return;
    applying = true;
    try {
      applySimple(root || document);
      applyRich(root || document);
    } finally {
      applying = false;
    }
  }

  function scheduleApply(target) {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      apply(target || document);
    }, 30);
  }

  /* ── Init ── */
  document.addEventListener("DOMContentLoaded", () => {
    apply(document);
    window.addEventListener("vinci:region_changed", () => scheduleApply(document));
    // Fallback de segurança: se algo falhar, exibe os preços/botões depois de 2s pra não ficar oculto pra sempre
    setTimeout(() => {
      document.querySelectorAll('[data-vr-pricing]:not(.vr-ready)').forEach(el => el.classList.add('vr-ready'));
      document.querySelectorAll('.bgz-product__buy-btn:not(.vr-ready)').forEach(el => el.classList.add('vr-ready'));
    }, 2000);
  });

  /* ── MutationObserver para nós adicionados dinamicamente ── */
  const mo = new MutationObserver(mutations => {
    if (applying) return;
    let hasNew = false;
    for (const m of mutations) {
      if (m.type !== "childList" || !m.addedNodes?.length) continue;
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.("[data-vr-price],[data-vr-pricing]") ||
            node.querySelector?.("[data-vr-price],[data-vr-pricing]")) {
          hasNew = true;
          break;
        }
      }
      if (hasNew) break;
    }
    if (hasNew) scheduleApply(document);
  });

  const startObs = () => {
    if (!document.body) return;
    mo.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObs);
  } else {
    startObs();
  }

  /* ── Hooks do editor Shopify ── */
  document.addEventListener("shopify:section:load", () => scheduleApply(document));
  document.addEventListener("shopify:section:select", () => scheduleApply(document));
})();
